module.exports = __webpack_public_path__ + "static/media/brand-logo-menu.bdf8e9e9.png";